import React, { useEffect, useState } from "react";
import "./styles.scss";

export interface ITabItem {
  key: string;
  label: string;
}

export interface ITabsProps {
  data: ITabItem[];
  defaultKey: string;
  onChanged: (key: string) => void;
}

const Tabs: React.FunctionComponent<ITabsProps> = ({
  data,
  defaultKey,
  onChanged,
}) => {
  const [selectedKey, setSelectedKey] = useState<string>(defaultKey);

  useEffect(() => {
    setSelectedKey(defaultKey);
  }, [defaultKey]);

  const handleClick = (key: string) => {
    if (key === selectedKey) {
      return;
    }

    setSelectedKey(key);
    onChanged(key);
  };

  return (
    <div className="ac-tabs" role="tablist">
      {data.map((item) => {
        const isSelected = item.key === selectedKey;

        return (
          <button
            type="button"
            role="tab"
            aria-selected={isSelected}
            key={item.key}
            className={`ac-tab ${isSelected ? "selected" : ""}`}
            onClick={() => handleClick(item.key)}
            disabled={isSelected}
          >
            {item.label}
          </button>
        );
      })}
    </div>
  );
};

export default Tabs;
